<template>
  <div>

    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">首页</div>

    <div style="background-color: #eee;overflow-y: scroll;" :style="th">

      <div style="padding: 10px">

        <div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">老人总数</div>
              <div style="">{{this.elderlyCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">男/女（老人）</div>
              <div style="">{{this.elderlyCountMan}}/{{this.elderlyCountWoman}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">商家总数</div>
              <div style="">{{this.businessCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">服务人员总数</div>
              <div style="">{{this.serveCount}}</div>
            </div>
          </div>
          <div style="float: left;width:20%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">设备总数</div>
              <div style="">{{this.deviceCount}}</div>
            </div>
          </div>

          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">报警总数/待处理报警数</div>
              <div style="">{{this.alarmRecordCount}}/{{this.alarmRecordCountWait}}</div>
            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;height: 80px;text-align: center;">
              <div style="line-height: 40px;">待处理投诉建议</div>
              <div style="">{{this.complaintCountWait}}</div>
            </div>
          </div>
          <div style="clear: both;"></div>
        </div>


        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">日销售统计</div>
                <ve-line :data="chartData_total_day" :settings="chartSettings_total_day"></ve-line>
              </div>

            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">月销售统计</div>
                <ve-histogram :data="chartData_total_month" :settings="chartSettings_total_month"></ve-histogram>
              </div>

            </div>
          </div>
          <div style="clear: both;"></div>
        </div>

        <div style="height: 10px;"></div>

        <div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">老人年龄分布</div>
                <ve-bar :data="chartData_elderly" :settings="chartSettings_elderly"></ve-bar>
              </div>
            </div>
          </div>
          <div style="float: left;width:50%;">
            <div style="background-color: #fff;margin: 0px 5px;">
              <div style="width: 100%;overflow: hidden;">
                <div style="text-align: center;padding: 20px">服务项目占比</div>
                <ve-pie :data="chartData_goods" :settings="chartSettings_goods"></ve-pie>
              </div>

            </div>
          </div>
          <div style="clear: both;"></div>
        </div>




      </div>

    </div>


  </div>

</template>



<script>


import {timeStr} from "@/common/times";
import {getGovernmentCode, getStaffCode, removeToken} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Home",
  components:{

  },
  data: function () {
    return {

      th:'',


      chartSettings_total_day:{
        labelMap:{
          day:"日期",
          count:"订单数",
          money:"销售额",
        }
      },
      chartData_total_day: {
        columns: ['day', 'count','money'],
        rows: [
          {'day':'1','count':'20','money':'200'},
        ]
      },




      chartSettings_total_month:{
        labelMap:{
          month:"月份",
          count:"订单数",
          money:"销售额",
        }
      },
      chartData_total_month: {
        columns: ['month', 'count','money'],
        rows: [
          {'month':'1','count':'203','money':'2000'},
        ]
      },




      chartSettings_elderly:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          age:"年龄",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          man:"男",
          woman:'女',
        }
      },
      chartData_elderly: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['age', 'man','woman'],
        rows: [
          {'age':'60-65','man':'20','woman':'22'},
          {'age':'66-70','man':'14','woman':'17'},
          {'age':'71-75','man':'10','woman':'12'},
          {'age':'76-80','man':'8','woman':'7'},
          {'age':'81-120','man':'7','woman':'4'},
        ]
      },

      chartSettings_goods:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          class:"项目分类",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          total:"销售占比"
        }
      },
      chartData_goods: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['class', 'total'],
        rows: [
          {'class':'家政','total':'203'},
          {'class':'助餐','total':'143'},
          {'class':'护理','total':'93'},
          {'class':'康复','total':'60'},
          {'class':'精神慰藉','total':'35'},
          {'class':'智能设备','total':'22'},
        ]
      },



      elderlyCount:0,
      elderlyCountMan:0,
      elderlyCountWoman:0,

      businessCount:0,
      serveCount:0,
      deviceCount:0,

      alarmRecordCount:0,
      alarmRecordCountWait:0,

      complaintCountWait:0,


    }
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = "height:"+(val+140-25)+"px";
    },
  },
  created(){
    this.th = "height:"+(this.$store.state.tableHeight+140-25)+"px";

    this.getElderlyCount();

    this.getBusinessCount();

    this.getServeCount();

    this.getDeviceCount();

    this.getAlarmRecordCount();

    this.getTotalOrder();

    this.getAge();


    this.getComplaintCount();

  },
  methods:{



    loginOut(){

      removeToken();

      window.localStorage.setItem('activeInstitutionCode', null);
      window.localStorage.setItem('activeStaffCode', null);
      window.localStorage.setItem('activeMenuTop', null);
      window.localStorage.setItem('listMenuDTO', null);
      window.localStorage.setItem('listMenuTop', null);
      window.localStorage.setItem('listMenuLeft', null);
      window.localStorage.setItem('isHome', null);

      this.$store.commit('update', ['loginToken',null]);


      this.$router.push({ path: '/login' })

    },

    getElderlyCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.elderlyCount = response.data.data.elderlyCount;
              this.elderlyCountMan = response.data.data.elderlyCountMan;
              this.elderlyCountWoman = response.data.data.elderlyCountWoman;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getBusinessCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
            if (response.data.error == 0) {
              this.businessCount = response.data.data.businessCount;
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)

              if(response.data.message.indexOf("禁用")!=-1){
                this.loginOut();
              }

            }
          })

    },


    getServeCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Serve/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.serveCount = response.data.data.serveCount;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getDeviceCount(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"UserDevice/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode:getGovernmentCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.deviceCount = response.data.data.deviceCount;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getAlarmRecordCount(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"AlarmRecord/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode:getGovernmentCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {

              this.alarmRecordCount = response.data.data.alarmCount;
              this.alarmRecordCountWait = response.data.data.alarmCountWait;

            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


    getTotalOrder(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Total/Pannel",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
            if (response.data.error == 0) {

              let listTotalOrderDay = response.data.data.listTotalOrderDay;
              let arr = [];
              for(let i=0;i<listTotalOrderDay.length;i++){
                arr.push({"day":listTotalOrderDay[i].day,"count":listTotalOrderDay[i].orderCount,"money":listTotalOrderDay[i].orderMoney});
              }
              this.chartData_total_day.rows = arr;

              let listTotalOrderMonth = response.data.data.listTotalOrderMonth;
              let arr2 = [];
              for(let i=0;i<listTotalOrderMonth.length;i++){
                arr2.push({"month":listTotalOrderMonth[i].month,"count":listTotalOrderMonth[i].orderCount,"money":listTotalOrderMonth[i].orderMoney});
              }
              this.chartData_total_month.rows = arr2;

              let listTotalGoodsClassGovernment = response.data.data.listTotalGoodsClassGovernment;
              let arr3 = [];
              for(let i=0;i<listTotalGoodsClassGovernment.length;i++){
                arr3.push({"class":listTotalGoodsClassGovernment[i].goodsClassName,"total":listTotalGoodsClassGovernment[i].orderCount+''});
              }
              this.chartData_goods.rows = arr3;


            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          })

    },


    getAge(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Elderly/PannelAgeCount",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error == 0) {


          this.chartData_elderly.rows = response.data.data.jsonArray;


        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },

    getComplaintCount(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Complaint/ListWait",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.complaintCountWait = response.data.data.count;
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )

    },


  }

}


</script>

